import { render } from "./NewOrgEnrollment.vue?vue&type=template&id=276fb395&scoped=true"
import script from "./NewOrgEnrollment.vue?vue&type=script&lang=js"
export * from "./NewOrgEnrollment.vue?vue&type=script&lang=js"

import "./NewOrgEnrollment.vue?vue&type=style&index=0&id=276fb395&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276fb395"]])

export default __exports__